import React from 'react';
import {
	TabContext,
	TabList,
	TabPanel,
	TabContextProps,
	TabListProps,
	TabPanelProps,
} from '@mui/lab';
import { Box, Divider, Tab, BoxProps, DividerProps, TabProps } from '@mui/material';
import SwipeableViews from 'react-swipeable-views';
import styled from 'styled-components';
import { useMediaQuery, useTheme } from '@mui/material';

interface TabItem {
	label: string;
	value: string;
	content: React.ReactNode;
}

interface CustomTabProps {
	tabValue: string;
	handleTabChange: (event: React.SyntheticEvent, newValue: string) => void;
	tabs: TabItem[];
	sx?: any;
}

const StyledTabList = styled(TabList)<TabListProps>`
	padding-left: 16px;
	border-bottom: none !important;
	overflow-x: auto; /* Add horizontal scrolling */
	white-space: nowrap; /* Prevent tabs from wrapping */
`;

const StyledTab = styled(Tab)<TabProps>`
	font-size: 14px;
	font-weight: 600;
	min-width: 132px;
	height: 51px;
	color: var(--color-font-grey);
`;

const StyledTabPanel = styled(TabPanel)<TabPanelProps>`
	padding: 0 !important;
	height: 100vh;
	overflow-y: auto;
`;

const CustomTab: React.FC<CustomTabProps> = ({ tabValue, handleTabChange, tabs, sx = {} }) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<TabContext value={tabValue}>
			<Box sx={{ width: '100%', flexShrink: 0 }}>
				<StyledTabList
					onChange={handleTabChange}
					aria-label="lab API tabs example"
					scrollButtons="auto"
					variant={isMobile ? 'scrollable' : 'standard'}
					sx={{
						borderBottom: '1px solid #f1f1f1',
						'& .Mui-selected': {
							borderBottom: '1.5px solid #fff2cc !important',
							color: 'var(--default-text-color) !important',
							fontSize: '14px !important',
							fontWeight: '700 !important',
							lineHeight: '19.1px !important',
						},
					}}
				>
					{tabs.map((tab) => (
						<StyledTab key={tab.value} label={tab.label} value={tab.value} />
					))}
				</StyledTabList>
				<Divider style={{ borderBottom: '1.5px solid var(--gray-color-light)' }} />
			</Box>
			{/* <SwipeableViews
				index={tabs.findIndex((tab) => tab.value === tabValue)}
				//@ts-ignore
				onChangeIndex={(index) => handleTabChange(null, tabs[index].value)}
			> */}
			{tabs?.map((tab) => (
				<StyledTabPanel sx={{ ...sx }} key={tab.value} value={tab.value}>
					{tab.content}
				</StyledTabPanel>
			))}
			{/* </SwipeableViews> */}
		</TabContext>
	);
};

export default CustomTab;
